import React, { HTMLProps } from 'react'

import { IoChevronBackOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router'

import { useUser } from '../../../context'
import { SectionComponent } from '../../../types'

import {
  ContentSection,
  ContentHeader,
  ContentTitle,
  ContentChildren2,
  BackButton,
  CTAContainer,
} from './styles'

const Section = ({
  title,
  subtitle,
  children,
  children2,
  childrenClass,
  withBackBtn,
  backURL,
  ctaSection,
  ...props
}: SectionComponent & HTMLProps<HTMLDivElement>) => {
  const navigate = useNavigate()
  const { setOnEditionMode } = useUser()

  const handleGoBack = () => {
    if (backURL) {
      setOnEditionMode(false)
      navigate(backURL, { state: undefined })
    } else {
      navigate(-1)
    }
  }

  return (
    <ContentSection {...props}>
      {(title || subtitle || children2) && (
        <ContentHeader
          $flexDirection={ctaSection?.flexDirection}
          $alignItems={ctaSection?.alignItems}
        >
          <ContentTitle>
            <h1>
              {withBackBtn && (
                <BackButton onClick={handleGoBack}>
                  <IoChevronBackOutline />
                </BackButton>
              )}

              {title}
            </h1>

            {subtitle && <h3>{subtitle}</h3>}
          </ContentTitle>
          {ctaSection && <CTAContainer> {ctaSection.cta}</CTAContainer>}
          {children2 && <div className="children-2-mobile">{children2}</div>}
        </ContentHeader>
      )}

      <div className={childrenClass}>
        <div className="content-children">{children}</div>
        {children2 && <ContentChildren2>{children2} </ContentChildren2>}
      </div>
    </ContentSection>
  )
}

export default Section
